import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Separator } from '../../../../../CommonComponents/OPL/Separator/Separator';
import { Lozenge } from '../../../../../CommonComponents/OPL/Lozenge/Lozenge';
import { formatCurrency } from '../../../../../CommonUtils/formatNumber';

interface Props {
  name: string;
  color: string | null;
  valueLabel: string;
  value: number;
  type?: string;
  percentage: number;
}
export const Owner = ({ name, valueLabel, value, type, percentage, color }: Props) => {
  return (
    <Box
      width="220px"
      key={name}
      display="flex"
      flexDirection="column"
      alignItems="center"
      css={({ theme }) => ({
        gap: theme.space['8'],
        pageBreakInside: 'avoid',
        breakInside: 'avoid',
      })}
      p="16"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="100%"
        height="45px"
      >
        <Text
          fontWeight={600}
          color="neutral.700"
          textTransform="uppercase"
          textAlign="center"
          fontSize="h6"
        >
          {name}
        </Text>
      </Box>

      <Box width="100%">
        <Separator />
      </Box>

      <Text variant="smallCaps" color="neutral.500">
        {valueLabel}
      </Text>

      <Text variant="tabular" fontSize="h4" fontWeight={500}>
        {formatCurrency(value)}
      </Text>

      {type && <Lozenge variantColor="primary">{type}</Lozenge>}

      <Text
        variant="tabular"
        fontWeight={600}
        textAlign="center"
        color="blue.700"
        {...(color ? { style: { color } } : {})}
      >
        {percentage}%
      </Text>
    </Box>
  );
};
